// import '@ant-design/compatible/assets/index.css';


import { useQuery } from 'react-query';
import React, { useCallback, useEffect, useState } from 'react';

import {
  Radio,
  Col,
  Spin,
  Row,
  Typography,
  Divider,
  Select,
  notification,
  message,
} from 'antd';
import * as finEngine from 'services/finEngine';
import DF from 'DisplayFramework';
import { toCurrency } from 'utils/utils';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import {
  getFinContractById,
  getFinModificationValidByCtrid,
  getFinModificationByModid,
  changeDueDate,
  FinConElementResponse,
} from 'services/fincontract';
import { FormInstance } from 'antd/lib/form';
import InputMoney from 'components/InputMoney';
import TextArea from 'antd/lib/input/TextArea';
import PricingListSelect from 'components/PricingListSelect';

import { PricingResponse } from 'services/pricing';
import { dateToString } from 'utils/utils2';
import InputRate from 'components/InputRate';

const { Text } = Typography;

export type TabContractChangeDueDateProps = {
  objectid: number;
  object: string;
  form?: FormInstance;
  setSuccessful?: any;
};

const TabContractChangeDueDate = ({
  objectid,
  object,
  form,
  setSuccessful,
}: TabContractChangeDueDateProps) => {
  const [state, setState] = useState({
    isLoading: false,
    isModSelected: false,
    newDueDate: '01',
    effectDate: '',
    feesAmount: 0,
    feesFormula: '',
    newElements: [] as FinConElementResponse[],
  });

  const { data: contract, isLoading } = useQuery(
    ['getFinContractById', { ctrid: objectid }],
    () => getFinContractById({ ctrid: objectid }).then((res) => res.data),
    { refetchOnMount: true }
  );

  const { data: modList, isFetching } = useQuery(
    ['getFinModificationValidByCtrid', { ctrid: objectid }],
    () =>
      getFinModificationValidByCtrid({
        ctrid: objectid,
        modevent: 'CHANGEDUEDATE',
      }).then((res) => res.list),
    { refetchOnMount: true }
  );

  useEffect(() => {
    setSuccessful(isLoading && isFetching);
  }, [isLoading, isFetching]);

  const handleFinModSelect = (finmod: number) => {
    if (finmod === undefined) {
      updateState({ isModSelected: false });
      return;
    }

    updateState({ isLoading: true });

    let query = getFinModificationByModid({ modid: finmod });

    query.then((response) => {
      if (response.code !== '200') {
        return;
      }

      const res = response.data;
      form?.setFieldsValue({
        mode: 'REAL',
        newDueDate: res.simulParams.filter(
          (item) => item.parcode === 'DUEDATE' && item.partype === 'IN'
        )[0].newvalue,
        effectDate: res.simulParams.filter(
          (item) => item.parcode === 'EFFECTDATE' && item.partype === 'IN'
        )[0].newvalue,
        feesFormula: res.simulParams.filter(
          (item) => item.parcode === 'FEESFORM' && item.partype === 'IN'
        )[0].newvalue,
        feesAmount: res.simulParams.filter(
          (item) => item.parcode === 'FEESAMNT' && item.partype === 'IN'
        )[0].newvalue,
      });

      handleDueDateChange(
        res.simulParams.filter(
          (item) => item.parcode === 'DUEDATE' && item.partype === 'IN'
        )[0].newvalue
      );

      updateState({ isModSelected: true });

      updateState({ isLoading: false });
    });
  };

  const dueDateDefault = contract?.conElements?.find(
    (e) => e.ctetype === 'FIN'
  )?.ctebilligdate;
  const notInvoicedSchedule = contract?.conElements
    ?.find((e) => e.ctetype === 'FIN')
    ?.conElemSchedules.filter((s) => s.ciid === null);
  const offerid = contract?.offerid;
  const deferredinterestmethod = contract?.conElements?.find(
    (e) => e.ctetype === 'FIN'
  )?.ctedeferredinterestmethod;
  const ctenominalrate = contract?.conElements?.find(
    (e) => e.ctetype === 'FIN'
  )?.ctenominalrate;

  const optionDates = notInvoicedSchedule?.map((e, index) => (
    <option key={index} value={e.ctsduedate.toString()}>
      {e.ctsduedate}
    </option>
  ));

  const optionModListValid = modList?.map((e, index) => (
    <option key={index} value={e.modid}>
      {e.modcomment}
    </option>
  ));

  const optionsMode = [
    { label: 'Simulation', value: 'SIMUL' },
    { label: 'Real', value: 'REAL' },
  ];

  const updateState = useCallback(
    (values:any) => {
      setState((prev) => ({ ...prev, ...values }));
    },
    [setState]
  );

  const handleTargetDateChange = (value: any) => {
    const targetDate = value; //form?.getFieldValue('effectDate');
    const interestMethod = form?.getFieldValue('interestMethod');
    const nominalRate = form?.getFieldValue('nominalRate');
    const newDueDate = form?.getFieldValue('newDueDate');

    if (targetDate === '' || targetDate === undefined) {
      notification.error({
        message: 'Please select a target application date',
      });
      return;
    }

    if (newDueDate === '' || newDueDate === undefined) {
      notification.error({ message: 'Please select a Billing date' });
      return;
    }

    calculate(
      objectid,
      newDueDate,
      interestMethod,
      nominalRate,
      0,
      '',
      targetDate
    );
  };

  const handleDueDateChange = (value: any) => {
    const targetDate = form?.getFieldValue('effectDate');
    const interestMethod = form?.getFieldValue('interestMethod');
    const nominalRate = form?.getFieldValue('nominalRate');
    const newDueDate = value; //form?.getFieldValue('newDueDate');

    if (targetDate === '' || targetDate === undefined) {
      notification.error({
        message: 'Please select a target application date',
      });
      return;
    }

    if (newDueDate === '' || newDueDate === undefined) {
      notification.error({ message: 'Please select a Billing date' });
      return;
    }

    calculate(
      objectid,
      newDueDate,
      interestMethod,
      nominalRate,
      0,
      '',
      targetDate
    );
  };

  const handleInterestRateChange = (value: any) => {
    const targetDate = form?.getFieldValue('effectDate');
    const interestMethod = form?.getFieldValue('interestMethod');
    const nominalRate = value; //form?.getFieldValue('nominalRate');
    const newDueDate = form?.getFieldValue('newDueDate');

    if (targetDate === '' || targetDate === undefined) {
      notification.error({
        message: 'Please select a target application date',
      });
      return;
    }

    if (newDueDate === '' || newDueDate === undefined) {
      notification.error({ message: 'Please select a Billing date' });
      return;
    }

    calculate(
      objectid,
      newDueDate,
      interestMethod,
      nominalRate,
      0,
      '',
      targetDate
    );
  };

  const handleInterestMethodChange = (value: any) => {
    const targetDate = form?.getFieldValue('effectDate');
    const interestMethod = value; //form?.getFieldValue('interestMethod');
    const nominalRate = form?.getFieldValue('nominalRate');
    const newDueDate = form?.getFieldValue('newDueDate');

    if (targetDate === '' || targetDate === undefined) {
      notification.error({
        message: 'Please select a target application date',
      });
      return;
    }

    if (newDueDate === '' || newDueDate === undefined) {
      notification.error({ message: 'Please select a Billing date' });
      return;
    }

    calculate(
      objectid,
      newDueDate,
      interestMethod,
      nominalRate,
      0,
      '',
      targetDate
    );
  };

  const calculateFees = (pricing?: PricingResponse) => {
    finEngine
      .calculateServiceWithStep({
        servReq: {
          finSchedule: contract?.conElements[0].conElemSchedules ?? [],
          inDownPayment: 0,
          inFinAmount: contract?.conElements[0].ctefinancedamount ?? 0,
          inFollowGP: true,
          inGPDuration: contract?.conElements[0].ctegraceperiodduration ?? 0,
          inPstype: pricing?.ctecategory ?? '',
          inRoudingAmount: 2,
          inServcalculationmethod:
            pricing?.serviceResponse.servcalculationmethod ?? '',
          inServfixedamount: pricing?.serviceResponse.servfixedamount ?? 0,
          inServiceduration: pricing?.serviceResponse.servduration ?? '',
          inServpercentage: pricing?.serviceResponse.servpercentage ?? 0,
          inTaxcode: pricing?.taxcode ?? '',
          inTaxrate: 20,
          inDuration: contract?.conElements[0].cteduration ?? 0,
          inInvestAmount: contract?.conElements[0].cteinvestamount ?? 0,
          inAssetAmount: contract?.assets[0].assetnetamount ?? 0,
          inServperiodicity: pricing?.serviceResponse.servperiodicity ?? '1',
          inServDurationFree: pricing?.serviceResponse.servdurationdefault ?? 1,
          inStartDate: dateToString(form?.getFieldValue('effectDate')),
          inServbasis: pricing?.serviceResponse.servbasis ?? 'FLAT',

          inCalculatedamountbasis:
            pricing?.serviceResponse.calculatedamountbasis ?? 'FINANCING',

          inMarginoncalcultedamount:
            pricing?.serviceResponse.marginoncalulatedamount ?? 0,
          inAdditionalcostaftermargin:
            pricing?.serviceResponse.additionalcostaftermargin ?? 0,

          servStep: pricing?.serviceStepList ?? [],
        },
      })
      .then((res) => {
        if (res.success) {
          message.success('Service - ' + res.message);

          form?.setFieldsValue({
            feesAmount: res.installmentamount,
          });
        }
      });
  };

  const calculate = (
    ctrid: number,
    newDueDate: string,
    interestMethod: string,
    nominalRate: number,
    feesAmount: number,
    feesFormula: string,
    effectDate: string
  ) => {
    updateState({ isLoading: true });

    changeDueDate({
      ctrid: ctrid,
      taskid: 0,
      newDueDate: newDueDate,
      modid: 0,
      mode: 'CALCUL',
      interestMethod: interestMethod,
      nominalRate: nominalRate,
      invoiceFees: false,
      feesFormula: feesFormula,
      feesAmount: feesAmount,
      effectDate: effectDate,
    })
      .then((response) => {
        updateState({ isLoading: false });
        if (response.code !== '200') {
          notification.error({
            message: response.message,
            duration: 0,
          });
        } else {
          updateState({ newElements: response.data.conElements });
        }
      })
      .catch((err) => {
        message.error(
          'Error in calculation. please contact the service provider'
        );
      });
  };

  return (
    <DF.Provider pagcode="tabChangeDueDate" entity={object} entityid={objectid}>
      <Spin spinning={state.isLoading || isLoading} delay={500}>
        <Row>
          <Col span={24}>
            <Row gutter={[8, 8]}>
              <FormInput
                col
                xs={4}
                name="effectDate"
                rules={[{ required: true }]}
              >
                <Select
                  defaultValue=""
                  size="small"
                  style={{ width: '100%' }}
                  disabled={state.isModSelected}
                  onChange={handleTargetDateChange}
                >
                  {optionDates}
                </Select>
              </FormInput>

              <FormInput col xs={3} name="currentDueDate">
                <Text>{dueDateDefault}</Text>
              </FormInput>
              <FormInput
                col
                xs={5}
                name="newDueDate"
                rules={[{ required: true }]}
              >
                <ParListSelect
                  disabled={state.isModSelected}
                  parcode="BILLDATE"
                  defaultValue={dueDateDefault}
                  onChange={handleDueDateChange}
                />
              </FormInput>
              <FormInput
                col
                xs={7}
                name="interestMethod"
                rules={[{ required: true }]}
              >
                <ParListSelect
                  parcode="CTEDEFINT"
                  defaultValue={deferredinterestmethod}
                  offerid={offerid ?? 0}
                  onChange={handleInterestMethodChange}
                />
              </FormInput>
              <FormInput col xs={4} name="nominalRate">
                <InputRate
                  defaultValue={ctenominalrate}
                  style={{ width: '100%' }}
                  onChange={handleInterestRateChange}
                />
              </FormInput>
            </Row>

            <Row gutter={[8, 8]}>
              <FormInput
                col
                xs={12}
                name="feesFormula"
                rules={[{ required: true }]}
              >
                <PricingListSelect
                  //disabled={!getFieldValue('offerid')}
                  allowClear
                  disabled={state.isModSelected}
                  params={{
                    offerid: offerid ?? 0,
                    ctetype: 'MODFEES', // Modifictaion fees
                    ctecategory: '',
                    finamount: 0,
                    filters: '',
                  }}
                  onChange={(e) => calculateFees(e)}
                />
              </FormInput>
              <FormInput col xs={6} name="feesAmount">
                <InputMoney defaultValue={0} disabled={state.isModSelected} />
              </FormInput>
            </Row>

            <Row gutter={[8, 8]}>
              <FormInput col xs={6} name="mode" rules={[{ required: true }]}>
                <Radio.Group
                  options={optionsMode}
                  defaultValue="SIMUL"
                  optionType="button"
                  disabled={state.isModSelected}
                />
              </FormInput>
              <FormInput col xs={18} name="modid">
                <Select
                  size="small"
                  allowClear
                  style={{ width: '100%' }}
                  onChange={(e: number) => handleFinModSelect(e)}
                >
                  {optionModListValid}
                </Select>
              </FormInput>
            </Row>

            <Row gutter={[8, 8]}>
              <FormInput
                col
                xs={18}
                name="comment"
                rules={[{ required: true }]}
              >
                <TextArea rows={4} />
              </FormInput>
            </Row>

            <Divider orientation="left">Elements</Divider>
            <Row>
              <Col span={20}>
                <Row>
                  <Col span={3}>Element#</Col>
                  <Col span={3}>Type</Col>
                  <Col span={14}>Description</Col>

                  <Col span={4}>OldRentalAmount</Col>
                </Row>
                {contract?.conElements?.map((el, index) => (
                  <div key={index}>
                    <Row>
                      <Col span={3}>{el.cteorder}</Col>
                      <Col span={3}>{el.ctetypelabel}</Col>
                      <Col span={14}>{el.ctedescription}</Col>
                      <Col span={4}>
                        {toCurrency(el.cterentalamount, el.currcode)}
                      </Col>
                    </Row>
                  </div>
                ))}
              </Col>
              <Col span={4}>
                <Row>
                  <Col span={12}>NewRentalAmount</Col>
                  <Col span={12}>DeferredInterest</Col>
                </Row>
                {[...state.newElements]?.map((elN, indexN) => (
                  <div key={indexN}>
                    <Row>
                      <Col span={12}>
                        {toCurrency(elN.cterentalamount, elN.currcode)}
                      </Col>
                      <Col span={12}>
                        {toCurrency(elN.ctedeferredinterest, elN.currcode)}
                      </Col>
                    </Row>
                  </div>
                ))}
              </Col>
            </Row>
          </Col>
        </Row>
      </Spin>
    </DF.Provider>
  );
};
export default TabContractChangeDueDate;
